import { render, staticRenderFns } from "./PracticeAdd.vue?vue&type=template&id=1564833d&scoped=true&"
import script from "./PracticeAdd.vue?vue&type=script&lang=js&"
export * from "./PracticeAdd.vue?vue&type=script&lang=js&"
import style0 from "./PracticeAdd.vue?vue&type=style&index=0&id=1564833d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564833d",
  null
  
)

export default component.exports